import Decimal from 'decimal.js';

import { Percent } from '@/graphql/scalars';
import {
  AssetV2QsbsEligibility,
  AssetValueV2OwnershipType,
} from '@/types/schema';

import { AssetTaxSitusFormValue } from '../../entities/StructuredAssetsSubform/StructuredAssetsSubform.types';

// i'm not sure exactly what an asset is going to look like yet -- that'll be the next phase -- but i don't
// think it'll map perfectly to the form state, so i'm keeping it defined as a separate (duplicated) type
export interface Asset {
  id: string;
  valueId?: string; // if theres's already a Value entity in the backend, use this to associate
  qsbsEligibility: AssetV2QsbsEligibility;
  categoryId?: string;
  marketValue?: Decimal | null;
  displayName: string;
  doDelete?: boolean;
  valuationMethod: AssetValueV2OwnershipType | string; // string to support initial empty value
  shareCount?: Decimal | null;
  sharePrice?: Decimal | null;
  totalValue?: Decimal | null;
  ownedPercent?: Percent | null;
  assetStaticID?: string | null;
  // The display name from the previous valuation associated with the assetStaticID.
  // Used to detect renames — if the current displayName differs, we should not
  // carry forward the assetStaticID (the user semantically replaced the asset).
  assetStaticDisplayName?: string | null;
  // Asset-level tax situs (state of domicile or grantor residency) for this
  // asset. See StructuredAssetsSubform.types for the encoding contract.
  // Optional because legacy assets may have it unset; the BE default hook
  // backfills new AssetStatics to grantor residency at create time.
  taxSitus?: AssetTaxSitusFormValue;
  // Snapshot at form-load time so submits can detect a real situs change
  // (not just "user opened the modal, didn't touch the dropdown").
  _originalTaxSitus?: AssetTaxSitusFormValue;
}

export const NEW_ASSET_ID = 'NEW_ASSET';
